import React from 'react';
import { RichText as RichTextJSS } from '@sitecore-jss/sitecore-jss-react';

const RichText = ({ fields }) => <RichTextJSS field={fields.content} />;

export default RichText;
